<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1236'>
  <div class="flex"></div>
  <div class="flex-52">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Saved Bulletin Manager</div>
      <div class="bmw-sb-saved-groups">
        <div *ngFor='let group of savedBulletinGroups;let i=index'>
          <a class="bmw-sb-saved-group pointer flex-container" (click)='expandBulletinGroup[i] = !expandBulletinGroup[i]' [href]='"#sb" + i'
            data-toggle="collapse">
            <div class="flex-6">
              <i class="material-icons">folder_special</i>
            </div>
            <div class="flex">
              {{group?.title}}
            </div>
            <div class="flex">
              <div class="dropdown dropdown-pull-right btn-group">
                <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                <ul class="dropdown-menu">
                  <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#renameGroup" (click)='holdGroupToRename(group)'>
                    <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                      <i class="material-icons dp48" style="font-size:20px">edit</i>
                    </div>
                    <div class="col-md-9 bmw-no-gutter">
                      Rename
                    </div>
                  </li>
                  <li class="row bmw-no-gutter pointer" (click)='deleteGroup(group?.title)'>
                    <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                      <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                    </div>
                    <div class="col-lg-9 bmw-no-gutter">
                      Delete group
                    </div>
                  </li>
                  <li class="divider"></li>
                  <li class="row bmw-no-gutter pointer">
                    <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                      <i class="material-icons" style="font-size:20px">close</i>
                    </div>
                    <div class="col-lg-9 bmw-no-gutter" style="padding-left: 5px">
                      Cancel
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </a>
          <div [id]='"sb" + i' class="collapse bmw-saved-bulletins-in-group">
            <div class="flex-container row" *ngFor='let bulletin of group?.content'>
              <div class="bmw-saved-bulletin-in-group flex-container row flex-align-center">
                <div style="width: 100%" class="pointer" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                  <div class="flex-15">{{bulletin?.bulletinDisplayNumber}}</div>
                  <div class="flex-80">{{bulletin?.description}}</div>
                </div>
                <div class="flex">
                  <div class="dropdown dropdown-pull-right btn-group">
                    <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                    <ul class="dropdown-menu">
                      <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#addToGroup" (click)='holdBulletinToAddToNewGroup(bulletin)'>
                        <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">launch</i>
                        </div>
                        <div class="col-md-9 bmw-no-gutter">
                          Move to another group
                        </div>
                      </li>
                      <li class="row bmw-no-gutter pointer" (click)='deleteBulletinFromGroup(bulletin?.id)'>
                        <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter">
                          Delete
                        </div>
                      </li>
                      <li class="divider"></li>
                      <li class="row bmw-no-gutter pointer">
                        <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons" style="font-size:20px">close</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter" style="padding-left: 5px">
                          Cancel
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bmw-sb-bulletins">
        <div class="bmw-sb-add-folder-layout flex-container">
          <div class="flex">
            Bulletins
          </div>
        </div>
        <div class="bmw-sb-saved-groups">
          <div *ngFor='let bulletin of savedBulletins;let i=index'>
            <div class="bmw-sb-saved-bulletin pointer flex-container">
              <div style="width:100%" class="pointer flex-container" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                <div class="flex-7">
                  {{bulletin?.bulletinType}}
                </div>
                <div class="flex-15">
                  {{bulletin?.bulletinDisplayNumber}}
                </div>
                <div class="flex-75">
                  {{bulletin?.description}}
                </div>
              </div>
              <div class="flex">
                <div class="dropdown dropdown-pull-right btn-group pointer">
                  <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu">
                    <li class="row bmw-no-gutter pointer" (click)='deleteBulletin(bulletin?.id)'>
                      <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                        <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter">
                        Delete
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter pointer">
                      <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter" style="padding-left: 5px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal to add new group -->
    <div class="modal fade" id="addNewGroup" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="bmw-create-group-label">
              Create new group
            </div>
            <div class="bmw-sb-input">
              <input type="text" placeholder="ex Engine" [(ngModel)]='newGroupName'>
            </div>
          </div>
          <div class="bmw-sb-buttons flex-container row flex-align-center">
            <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
            <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
              (click)='addNewBulletinGroup(newGroupName)'>Create</div>
          </div>
        </div>

      </div>
    </div>
    <!-- Modal to add new bulletin -->
    <div class="modal fade" id="addNewBulletin" role="dialog" #addNewBulletinModal>
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="cms-modal-select-make-checkbox">
              <label class="container">SIB
                <input type="radio" name="radio" value="SIB" [(ngModel)]='inputBulletinType'>
                <span class="checkmark"></span>
              </label>
            
              <label class="container">PBS
                <input type="radio" name="radio" value="PBS" [(ngModel)]='inputBulletinType'>
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="bmw-create-group-label">
              Bulletin Number
            </div>
            <div class="bmw-sb-input">
              <input type="text" placeholder="ex 02 01 18" [(ngModel)]='bulletinId'>
            </div>
          </div>
          <small style="color: red">{{errorMessage}}</small>
          <div class="bmw-sb-buttons flex-container row flex-align-center">
            <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
            <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer"
              (click)='addNewBulletin(bulletinId)'>Add</div>
          </div>
        </div>

      </div>
    </div>
    <!-- Modal to add new bulletin -->
    <div class="modal fade" id="addToGroup" role="dialog">
      <div class="bmw-sb-addTo-other-group modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="bmw-sb-addTo-other-modal-title">
              Saved Bulletins Manager
            </div>
            <div class="bmw-sb-addTo-other-inputs">
              <div class="bmw-create-group-label">Add to existing group</div>
              <div>
                <select class="form-control" id="group" [(ngModel)]='userSelectedExistingGroup'>
                  <option [ngValue]="undefined" disabled selected> Select group </option>
                  <option *ngFor="let group of savedBulletinGroupsList" [ngValue]="group.groupName">{{group?.groupName}}</option>
                </select>
              </div>
              <div class="bmw-sb-addTo-other-input">
                <div class="bmw-create-group-label">Create new group</div>
                <input type="text" id="" placeholder="ex Engine" [(ngModel)]='newGroupName'>
              </div>
            </div>
          </div>
          <div class="bmw-sb-buttons flex-container row flex-align-center">
            <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
            <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
              (click)='addBulletinToNewOrExistingGroup(newGroupName, userSelectedExistingGroup)'>Create</div>
          </div>
        </div>

      </div>
    </div>
    <!-- Modal to rename group -->
    <div class="modal fade" id="renameGroup" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="bmw-create-group-label">
              Rename group
            </div>
            <div class="bmw-sb-input">
              <input type="text" placeholder="ex Engine" [(ngModel)]='changeGroupName'>
            </div>
          </div>
          <div class="bmw-sb-buttons flex-container row flex-align-center">
            <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
            <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
              (click)='renameGroup(changeGroupName)'>Rename</div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth > 991 && screenWidth < 1230'>
  <div class="visible-md">
    <div flex flexLayput="row">
      <div class="flex"></div>
      <div class="flex-80">
        <div class="bmw-profile-content bmw-md">
          <div class="bmw-user-info-title">Saved Bulletin Manager</div>

          <div class="bmw-sb-saved-groups">
            <div *ngFor='let group of savedBulletinGroups;let i=index'>
              <a class="bmw-sb-saved-group pointer flex-container" (click)='expandBulletinGroup[i] = !expandBulletinGroup[i]' [href]='"#sb" + i'
                data-toggle="collapse">
                <div class="flex-6">
                  <i class="material-icons">folder_special</i>
                </div>
                <div class="flex">
                  {{group?.title}}
                </div>
                <div class="flex">
                  <div class="dropdown dropdown-pull-right btn-group">
                    <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                    <ul class="dropdown-menu">
                      <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#renameGroup1" (click)='holdGroupToRename(group)'>
                        <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">edit</i>
                        </div>
                        <div class="col-md-9 bmw-no-gutter">
                          Rename
                        </div>
                      </li>
                      <li class="row bmw-no-gutter pointer" (click)='deleteGroup(group?.title)'>
                        <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                        </div>
                        <div class="col-md-9 bmw-no-gutter">
                          Delete group
                        </div>
                      </li>
                      <li class="divider"></li>
                      <li class="row bmw-no-gutter pointer">
                        <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons" style="font-size:20px">close</i>
                        </div>
                        <div class="col-md-9 bmw-no-gutter" style="padding-left: 5px">
                          Cancel
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </a>
              <div [id]='"sb" + i' class="collapse bmw-saved-bulletins-in-group">
                <div class="flex-container row" *ngFor='let bulletin of group?.content'>
                  <div class="bmw-saved-bulletin-in-group flex-container row flex-align-center">
                    <div style="width: 100%" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                      <div class="flex-15">{{bulletin?.bulletinDisplayNumber}}</div>
                      <div class="flex-80">{{bulletin?.description}}</div>
                    </div>
                    <div class="flex">
                      <div class="dropdown dropdown-pull-right btn-group">
                        <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                        <ul class="dropdown-menu">
                          <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#addToGroup1" (click)='holdBulletinToAddToNewGroup(bulletin)'>
                            <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons dp48" style="font-size:20px">launch</i>
                            </div>
                            <div class="col-md-9 bmw-no-gutter">
                              Move to another group
                            </div>
                          </li>
                          <li class="row bmw-no-gutter pointer" (click)='deleteBulletinFromGroup(bulletin?.id)'>
                            <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                            </div>
                            <div class="col-md-9 bmw-no-gutter">
                              Delete
                            </div>
                          </li>
                          <li class="divider"></li>
                          <li class="row bmw-no-gutter pointer">
                            <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons" style="font-size:20px">close</i>
                            </div>
                            <div class="col-md-9 bmw-no-gutter" style="padding-left: 5px">
                              Cancel
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bmw-sb-bulletins">
            <div class="bmw-sb-add-folder-layout flex-container">
              <div class="flex">
                Bulletins
              </div>
            </div>
            <div class="bmw-sb-saved-groups">
              <div *ngFor='let bulletin of savedBulletins;let i=index'>
                <a class="bmw-sb-saved-bulletin pointer flex-container">
                  <div style="width: 100%" class="pointer flex-container" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                    <div class="flex-7">
                      {{bulletin?.bulletinType}}
                    </div>
                    <div class="flex-15">
                      {{bulletin?.bulletinDisplayNumber}}
                    </div>
                    <div class="flex-75">
                      {{bulletin?.description}}
                    </div>
                  </div>
                  <div class="flex">
                    <div class="dropdown dropdown-pull-right btn-group">
                      <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                      <ul class="dropdown-menu">
                        <li class="row bmw-no-gutter pointer" (click)='deleteBulletin(bulletin?.id)'>
                          <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                            <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                          </div>
                          <div class="col-md-9 bmw-no-gutter">
                            Delete
                          </div>
                        </li>
                        <li class="divider"></li>
                        <li class="row bmw-no-gutter pointer">
                          <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                            <i class="material-icons" style="font-size:20px">close</i>
                          </div>
                          <div class="col-md-9 bmw-no-gutter" style="padding-left: 5px">
                            Cancel
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal to add new group -->
        <div class="modal fade" id="addNewGroup1" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Create new group
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex Engine" [(ngModel)]='newGroupName'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addNewBulletinGroup(newGroupName)'>Create</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to add new bulletin -->
        <div class="modal fade" id="addNewBulletin1" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Bulletin Number
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex 02 01 18" [(ngModel)]='bulletinId'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addNewBulletin(bulletinId)'>Add</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to add new bulletin -->
        <div class="modal fade" id="addToGroup1" role="dialog">
          <div class="bmw-sb-addTo-other-group modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-sb-addTo-other-modal-title">
                  Saved Bulletins Manager
                </div>
                <div class="bmw-sb-addTo-other-inputs">
                  <div class="bmw-create-group-label">Add to existing group</div>
                  <div>
                    <select class="form-control" id="group" [(ngModel)]='userSelectedExistingGroup'>
                      <option [ngValue]="undefined" disabled selected> Select group </option>
                      <option *ngFor="let group of savedBulletinGroupsList" [ngValue]="group.groupName">{{group?.groupName}}</option>
                    </select>
                  </div>
                  <div class="bmw-sb-addTo-other-input">
                    <div class="bmw-create-group-label">Create new group</div>
                    <input type="text" id="" placeholder="ex Engine" [(ngModel)]='newGroupName'>
                  </div>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addBulletinToNewOrExistingGroup(newGroupName, userSelectedExistingGroup)'>Create</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to rename group -->
        <div class="modal fade" id="renameGroup1" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Rename group
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex Engine" [(ngModel)]='changeGroupName'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='renameGroup(changeGroupName)'>Rename</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth > 767 && screenWidth < 991'>
  <div class="visible-sm">
    <div flex flexLayput="row">
      <div class="flex"></div>
      <div class="flex-80">
        <div class="bmw-profile-content bmw-md">
          <div class="bmw-user-info-title">Saved Bulletin Manager</div>
          <div class="bmw-sb-saved-groups">
            <div *ngFor='let group of savedBulletinGroups;let i=index'>
              <a class="bmw-sb-saved-group pointer flex-container" (click)='expandBulletinGroup[i] = !expandBulletinGroup[i]' [href]='"#sb" + i'
                data-toggle="collapse">
                <div class="flex-7">
                  <i class="material-icons">folder_special</i>
                </div>
                <div class="flex">
                  {{group?.title}}
                </div>
                <div class="flex">
                  <div class="dropdown dropdown-pull-right btn-group">
                    <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                    <ul class="dropdown-menu">
                      <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#renameGroup2" (click)='holdGroupToRename(group)'>
                        <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">edit</i>
                        </div>
                        <div class="col-sm-9 bmw-no-gutter">
                          Rename
                        </div>
                      </li>
                      <li class="row bmw-no-gutter pointer" (click)='deleteGroup(group?.title)'>
                        <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                        </div>
                        <div class="col-sm-9 bmw-no-gutter">
                          Delete group
                        </div>
                      </li>
                      <li class="divider"></li>
                      <li class="row bmw-no-gutter pointer">
                        <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons" style="font-size:20px">close</i>
                        </div>
                        <div class="col-sm-9 bmw-no-gutter" style="padding-left: 5px">
                          Cancel
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </a>
              <div [id]='"sb" + i' class="collapse bmw-saved-bulletins-in-group bmw-md">
                <div class="flex-container row" *ngFor='let bulletin of group?.content'>
                  <div class="bmw-saved-bulletin-in-group flex-container row flex-align-center">
                    <div style="width: 100%" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                      <div class="flex-15">{{bulletin?.bulletinDisplayNumber}}</div>
                      <div class="flex-80">{{bulletin?.description}}</div>
                    </div>
                    <div class="flex">
                      <div class="dropdown dropdown-pull-right btn-group">
                        <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                        <ul class="dropdown-menu">
                          <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#addToGroup2" (click)='holdBulletinToAddToNewGroup(bulletin)'>
                            <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons dp48" style="font-size:20px">launch</i>
                            </div>
                            <div class="col-sm-9 bmw-no-gutter">
                              Move to another group
                            </div>
                          </li>
                          <li class="row bmw-no-gutter pointer" (click)='deleteBulletinFromGroup(bulletin?.id)'>
                            <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                            </div>
                            <div class="col-sm-9 bmw-no-gutter">
                              Delete
                            </div>
                          </li>
                          <li class="divider"></li>
                          <li class="row bmw-no-gutter pointer">
                            <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons" style="font-size:20px">close</i>
                            </div>
                            <div class="col-sm-9 bmw-no-gutter" style="padding-left: 5px">
                              Cancel
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bmw-sb-bulletins">
            <div class="bmw-sb-add-folder-layout flex-container">
              <div class="flex">
                Bulletins
              </div>
              <!-- Commented - The function is not working or not needed
              <div class="flex">
                <div [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-sb-add-folder pointer" data-toggle="modal"
                  data-target="#addNewBulletin2">
                  <i class="material-icons">add</i>
                  <div>Add Bulletin</div>
                </div>
              </div>-->
            </div>
            <div class="bmw-sb-saved-groups">
              <div *ngFor='let bulletin of savedBulletins;let i=index'>
                <a class="bmw-sb-saved-bulletin bmw-md pointer flex-container">
                  <div style="width: 100%" class="pointer flex-container" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                    <div class="flex-7">
                      {{bulletin?.bulletinType}}
                    </div>
                    <div class="flex-15">
                      {{bulletin?.bulletinDisplayNumber}}
                    </div>
                    <div class="flex-75">
                      {{bulletin?.description}}
                    </div>
                  </div>
                  <div class="flex">
                    <div class="dropdown dropdown-pull-right btn-group">
                      <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                      <ul class="dropdown-menu">
                        <li class="row bmw-no-gutter pointer" (click)='deleteBulletin(bulletin?.id)'>
                          <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                            <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                          </div>
                          <div class="col-sm-9 bmw-no-gutter">
                            Delete
                          </div>
                        </li>
                        <li class="divider"></li>
                        <li class="row bmw-no-gutter pointer">
                          <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                            <i class="material-icons" style="font-size:20px">close</i>
                          </div>
                          <div class="col-sm-9 bmw-no-gutter" style="padding-left: 5px">
                            Cancel
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal to add new group -->
        <div class="modal fade" id="addNewGroup2" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Create new group
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex Engine" [(ngModel)]='newGroupName'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addNewBulletinGroup(newGroupName)'>Create</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to add new bulletin -->
        <div class="modal fade" id="addNewBulletin2" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Bulletin Number
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex 02 01 18" [(ngModel)]='bulletinId'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addNewBulletin(bulletinId)'>Add</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to add new bulletin -->
        <div class="modal fade" id="addToGroup2" role="dialog">
          <div class="bmw-sb-addTo-other-group modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-sb-addTo-other-modal-title">
                  Saved Bulletins Manager
                </div>
                <div class="bmw-sb-addTo-other-inputs">
                  <div class="bmw-create-group-label">Add to existing group</div>
                  <div>
                    <select class="form-control" id="group" [(ngModel)]='userSelectedExistingGroup'>
                      <option [ngValue]="undefined" disabled selected> Select group </option>
                      <option *ngFor="let group of savedBulletinGroupsList" [ngValue]="group.groupName">{{group?.groupName}}</option>
                    </select>
                  </div>
                  <div class="bmw-sb-addTo-other-input">
                    <div class="bmw-create-group-label">Create new group</div>
                    <input type="text" id="" placeholder="ex Engine" [(ngModel)]='newGroupName'>
                  </div>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addBulletinToNewOrExistingGroup(newGroupName, userSelectedExistingGroup)'>Create</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to rename group -->
        <div class="modal fade" id="renameGroup2" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Rename group
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex Engine" [(ngModel)]='changeGroupName'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='renameGroup(changeGroupName)'>Rename</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div flex flexLayput="row">
      <div>
        <div class="bmw-profile-content bmw-xs">
          <div class="bmw-user-info-title bmw-xs">Saved Bulletin Manager</div>

          <div class="bmw-sb-saved-groups">
            <div *ngFor='let group of savedBulletinGroups;let i=index'>
              <a class="bmw-sb-saved-group pointer flex-container row" (click)='expandBulletinGroup[i] = !expandBulletinGroup[i]' [href]='"#sb" + i'
                data-toggle="collapse">
                <div class="flex-8">
                  <i class="material-icons">folder_special</i>
                </div>
                <div class="flex">
                  {{group?.title}}
                </div>
                <div class="flex">
                  <div class="dropdown dropdown-pull-right btn-group">
                    <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                    <ul class="dropdown-menu">
                      <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#renameGroup2" (click)='holdGroupToRename(group)'>
                        <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">edit</i>
                        </div>
                        <div class="col-xs-9 bmw-no-gutter">
                          Rename
                        </div>
                      </li>
                      <li class="row bmw-no-gutter pointer" (click)='deleteGroup(group?.title)'>
                        <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                        </div>
                        <div class="col-xs-9 bmw-no-gutter">
                          Delete group
                        </div>
                      </li>
                      <li class="divider"></li>
                      <li class="row bmw-no-gutter pointer">
                        <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                          <i class="material-icons" style="font-size:20px">close</i>
                        </div>
                        <div class="col-xs-9 bmw-no-gutter" style="padding-left: 5px">
                          Cancel
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </a>
              <div [id]='"sb" + i' class="collapse bmw-saved-bulletins-in-group bmw-md">
                <div class="flex-container row" *ngFor='let bulletin of group?.content'>
                  <div class="bmw-saved-bulletin-in-group flex-container row flex-align-center">
                    <div style="width: 100%" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                      <div class="flex-15">{{bulletin?.bulletinDisplayNumber}}</div>
                      <div class="flex-80">{{bulletin?.description}}</div>
                    </div>
                    <div class="flex">
                      <div class="dropdown dropdown-pull-right btn-group">
                        <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                        <ul class="dropdown-menu">
                          <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#addToGroup2" (click)='holdBulletinToAddToNewGroup(bulletin)'>
                            <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons dp48" style="font-size:20px">launch</i>
                            </div>
                            <div class="col-xs-9 bmw-no-gutter">
                              Move to another group
                            </div>
                          </li>
                          <li class="row bmw-no-gutter pointer" (click)='deleteBulletinFromGroup(bulletin?.id)'>
                            <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                            </div>
                            <div class="col-xs-9 bmw-no-gutter">
                              Delete
                            </div>
                          </li>
                          <li class="divider"></li>
                          <li class="row bmw-no-gutter pointer">
                            <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                              <i class="material-icons" style="font-size:20px">close</i>
                            </div>
                            <div class="col-xs-9 bmw-no-gutter" style="padding-left: 5px">
                              Cancel
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bmw-sb-bulletins">
            <div class="bmw-sb-add-folder-layout flex-container">
              <div class="flex">
                Bulletins
              </div>
            </div>
            <div class="bmw-sb-saved-groups">
              <div *ngFor='let bulletin of savedBulletins;let i=index'>
                <a class="bmw-sb-saved-bulletin bmw-md pointer flex-container">
                  <div style="width: 100%" class="pointer flex-container" [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]" [queryParams]='{type: bulletin?.bulletinType}'>
                    <div class="flex-7">
                      {{bulletin?.bulletinType}}
                    </div>
                    <div class="flex-15">
                      {{bulletin?.bulletinDisplayNumber}}
                    </div>
                    <div class="flex-75">
                      {{bulletin?.description}}
                    </div>
                  </div>
                  <div class="flex">
                    <div class="dropdown dropdown-pull-right btn-group">
                      <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
                      <ul class="dropdown-menu">
                        <li class="row bmw-no-gutter pointer" (click)='deleteBulletin(bulletin?.id)'>
                          <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                            <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                          </div>
                          <div class="col-xs-9 bmw-no-gutter">
                            Delete
                          </div>
                        </li>
                        <li class="divider"></li>
                        <li class="row bmw-no-gutter pointer">
                          <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                            <i class="material-icons" style="font-size:20px">close</i>
                          </div>
                          <div class="col-xs-9 bmw-no-gutter" style="padding-left: 5px">
                            Cancel
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div [routerLink]='["/profile"]' class="bmw-button-secondary bmw-xs pointer">Back</div>
        </div>
        <!-- Modal to add new group -->
        <div class="modal fade" id="addNewGroup2" role="dialog">
          <div class="modal-dialog bmw-xs">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Create new group
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex Engine" [(ngModel)]='newGroupName'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addNewBulletinGroup(newGroupName)'>Create</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to add new bulletin -->
        <div class="modal fade" id="addNewBulletin2" role="dialog">
          <div class="modal-dialog bmw-xs">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Bulletin Number
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex 02 01 18" [(ngModel)]='bulletinId'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center" >
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addNewBulletin(bulletinId)'>Add</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to add new bulletin -->
        <div class="modal fade" id="addToGroup2" role="dialog">
          <div class="bmw-sb-addTo-other-group modal-dialog bmw-xs">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-sb-addTo-other-modal-title bmw-xs">
                  Saved Bulletins Manager
                </div>
                <div class="bmw-sb-addTo-other-inputs">
                  <div class="bmw-create-group-label">Add to existing group</div>
                  <div>
                    <select class="form-control" id="group" [(ngModel)]='userSelectedExistingGroup'>
                      <option [ngValue]="undefined" disabled selected> Select group </option>
                      <option *ngFor="let group of savedBulletinGroupsList" [ngValue]="group.groupName">{{group?.groupName}}</option>
                    </select>
                  </div>
                  <div class="bmw-sb-addTo-other-input">
                    <div class="bmw-create-group-label">Create new group</div>
                    <input type="text" id="" placeholder="ex Engine" [(ngModel)]='newGroupName'>
                  </div>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='addBulletinToNewOrExistingGroup(newGroupName, userSelectedExistingGroup)'>Create</div>
              </div>
            </div>

          </div>
        </div>
        <!-- Modal to rename group -->
        <div class="modal fade" id="renameGroup2" role="dialog">
          <div class="modal-dialog bmw-xs">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-body">
                <div class="bmw-create-group-label">
                  Rename group
                </div>
                <div class="bmw-sb-input">
                  <input type="text" placeholder="ex Engine" [(ngModel)]='changeGroupName'>
                </div>
              </div>
              <div class="bmw-sb-buttons flex-container row flex-align-center">
                <div class="bmw-button-secondary pointer" data-dismiss="modal">Cancel</div>
                <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer" data-dismiss="modal"
                  (click)='renameGroup(changeGroupName)'>Rename</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>